<template>
    <div class="container ">
        <!-- 顶部警告通知 - 永远在最顶部 -->
        <marquee v-if="showWarningBar" class="top-notice">
            平台将于今晚（2026年5月9日）23:00 进行数据库升级维护，期间平台会出现短暂无法访问的情况，预计持续数分钟。建议您提前保存相关内容并做好安排。给您带来的不便，我们深表歉意，感谢您的理解与支持！
        </marquee>
        <page-header :style="{top: showWarningBar ? '32px' : 0}" ref="pageHeader" :back-color="isShowHeader" @openLoginDiolog="goLogin"
            @clearUserInfo="clearLoginObj" :state="isHaveLoginObj"></page-header>
        <div class="backImg">
            <el-carousel>
                <el-carousel-item v-for="(item, index) in list_img" :key="index">
                    <h3 class="small">
                        <img :src="item.url" alt />
                    </h3>
                </el-carousel-item>
            </el-carousel>
        </div>

        <div class="centerContainBox">
            <div class="groupPaperBox xy-center">
                <div class="jf groupItem xy-center">
                    <img src="../../assets/img/zixun.png" alt="" />
                    <div class="text yx-between-start">
                        <div class="font-size18">灵活组卷</div>
                        <div class="font-size14 c-BAC0CA">
                            Flexible test paper
                        </div>
                    </div>
                </div>

                <div class="jf groupItem xy-center">
                    <img src="../../assets/img/bianji-2.png" alt="" />
                    <div class="text yx-between-start">
                        <div class="font-size18">海量题库</div>
                        <div class="font-size14 c-BAC0CA">
                            Massive question ban
                        </div>
                    </div>
                </div>

                <div class="jf groupItem xy-center three">
                    <img src="../../assets/img/baogao1.png" alt="" />
                    <div class="text yx-between-start">
                        <div class="font-size18">培训考试</div>
                        <div class="font-size14 c-BAC0CA">
                            Training examination
                        </div>
                    </div>
                </div>
            </div>

            <!-- 快讯 -->
            <div class="alerts">
                <div class="alertsBox" ref="alertsBox">
                    <div class="examItem xy-center" v-for="(item, i) in ExamListInfo" :key="i">
                        <div class="image">
                            <img src="../../assets/img/alerts.png" alt="" />
                        </div>
                        <div class="auto-grow xy-between">
                            <div>{{ item.OrganName }}</div>
                            <div>{{ item.ExamName }}</div>
                            <div>开始时间：{{ item.BeginTime }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 执业资格 -->
            <div class="qualification">
                <div class="tit font-size24 c-256CF4 xy-center">
                    <img src="../../assets/img/qualificationTit.png" alt="" />
                    执业资格
                </div>
                <ul class="module " v-if="practitionersList && practitionersList.length">
                    <li class="moduleItem xy-center practitioners">
                        <div class="liteeBox yx-center  mousemove" @click="jumpTopic(columName[0].id)">
                            <img src="../../assets/img/Medical practitioners.png" alt="" />
                            <div class="font-size18 columtext">
                                {{ columName[0].name }}
                            </div>
                        </div>
                        <div class="practitionersHover">
                            <div class="content jf" v-for="(item, i) in physiciansList" :key="i">
                                <div class="imgText xy-center font-size16 ">
                                    <img src="../../assets/img/folder.png" alt="" />
                                    <div class="text">
                                        {{ item.CategoryName }}
                                    </div>
                                </div>
                                <!-- 滑块组件 -->
                                <the-slider :list="item.Modules" :total-list="physiciansList" :id="item.CategoryID"
                                    @toLogin="goLogin">
                                </the-slider>
                            </div>
                        </div>
                    </li>

                    <li class="moduleItem xy-center Assistant">
                        <div class="liteeBox yx-center" @click="jumpTopic(columName[1].id)">
                            <img src="../../assets/img/Assistant.png" alt="" />
                            <div class="font-size18  columtext">
                                {{ columName[1].name }}
                            </div>
                        </div>

                        <div class="AssistantHover">
                            <div class="content jf" v-for="(item, i) in ractitionerAssistant" :key="i">
                                <div class="imgText xy-center font-size16 ">
                                    <img src="../../assets/img/folder4.png" alt="" />
                                    <div class="text">
                                        {{ item.CategoryName }}
                                    </div>
                                </div>
                                <the-slider :list="item.Modules" :total-list="ractitionerAssistant"
                                    :id="item.CategoryID" @toLogin="goLogin">
                                </the-slider>
                            </div>
                        </div>
                    </li>

                    <li class="moduleItem xy-center pharmacist">
                        <div class="liteeBox yx-center" @click="jumpTopic(columName[2].id)">
                            <img src="../../assets/img/pharmacist.png" alt="" />
                            <div class="font-size18  columtext">
                                {{ columName[2].name }}
                            </div>
                        </div>

                        <div class="pharmacistHover">
                            <div class="content jf" v-for="(item, i) in LicensedPharmacists" :key="i">
                                <div class="imgText xy-center font-size16">
                                    <img src="../../assets/img/folder6.png" alt="" />
                                    <div class="text">
                                        {{ item.CategoryName }}
                                    </div>
                                </div>
                                <!-- 滑块组件 -->
                                <the-slider :list="item.Modules" :total-list="LicensedPharmacists" :id="item.CategoryID"
                                    @toLogin="goLogin">
                                </the-slider>
                            </div>
                        </div>
                    </li>

                    <li class="moduleItem xy-center nurse">
                        <div class="liteeBox yx-center" @click="jumpTopic(columName[3].id)">
                            <img src="../../assets/img/nurse.png" alt="" />
                            <div class="font-size18 columtext">
                                {{ columName[3].name }}
                            </div>
                        </div>

                        <div class="nursetHover">
                            <div class="content jf" v-for="(item, i) in nursePharmacists" :key="i">
                                <div class="imgText xy-center font-size16">
                                    <img src="../../assets/img/folder3.png" alt="" />
                                    <div class="text">
                                        {{ item.CategoryName }}
                                    </div>
                                </div>

                                <!-- 滑块组件 -->
                                <the-slider :list="item.Modules" :total-list="nursePharmacists" :id="item.CategoryID"
                                    @toLogin="goLogin">
                                </the-slider>
                            </div>
                        </div>
                    </li>

                    <!-- 卫生专业技术 -->
                    <li class="moduleItem xy-center health">
                        <div class="liteeBox yx-center" @click="jumpTopic(columName[4].id)">
                            <img src="../../assets/img/health.png" alt="" />
                            <div class="font-size18 columtext">
                                {{ columName[4].name }}
                            </div>
                        </div>

                        <div class="healthHover">
                            <div class="content jf" v-for="(item, i) in HealthQualification" :key="i">
                                <div class="imgText xy-center font-size16">
                                    <img src="../../assets/img/folder5.png" alt="" />
                                    <div class="text">
                                        {{ item.CategoryName }}
                                    </div>
                                </div>

                                <!-- 滑块组件 -->
                                <the-slider :list="item.Modules" :total-list="HealthQualification" :id="item.CategoryID"
                                    @toLogin="goLogin">
                                </the-slider>
                            </div>
                        </div>
                    </li>

                    <li class="moduleItem xy-center hospital">
                        <div class="liteeBox yx-center" @click="jumpTopic(columName[5].id)">
                            <img src="../../assets/img/hospital.png" alt="" />
                            <div class="font-size18 columtext">
                                {{ columName[5].name }}
                            </div>
                        </div>
                        <div class="hospitalHover">
                            <div class="content jf" v-for="(item, i) in hospitalTest" :key="i">
                                <div class="imgText xy-center font-size16">
                                    <img src="../../assets/img/floder7.png" alt="" />
                                    <div class="text">
                                        {{ item.CategoryName }}
                                    </div>
                                </div>
                                <!-- 滑块组件 -->
                                <the-slider :list="item.Modules" :total-list="hospitalTest" :id="item.CategoryID"
                                    @toLogin="goLogin">
                                </the-slider>
                            </div>
                        </div>
                    </li>

                    <li class="moduleItem xy-center sanki">
                        <div class="liteeBox yx-center" @click="jumpTopic(columName[7].id)">
                            <img src="../../assets/img/sanki.png" alt="" />
                            <div class="font-size18 columtext">
                                {{ columName[7].name }}
                            </div>
                        </div>
                        <div class="sankiHover">
                            <div class="content jf" v-for="(item, i) in medicalSankiList" :key="i">
                                <div class="imgText xy-center font-size16">
                                    <img src="../../assets/img/folder2.png" alt="" />
                                    <div class="text">
                                        {{ item.CategoryName }}
                                    </div>
                                </div>
                                <!-- 滑块组件 -->
                                <the-slider :list="item.Modules" :total-list="medicalSankiList" :id="item.CategoryID"
                                    @toLogin="goLogin">
                                </the-slider>
                            </div>
                        </div>
                    </li>

                    <li class="moduleItem xy-center" @click.stop="moduleClick">
                        <div class="liteeBox yx-center">
                            <img src="../../assets/img/more.png" alt="" />
                            <div class="font-size18 ">更多</div>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 执业资格 -->

            <!-- 科室导航 -->
            <div class="navigation">
                <div class="tit font-size24 c-256CF4 xy-center">
                    <img src="../../assets/img/qualificationTit.png" alt="" />
                    科室导航
                </div>

                <div class="contentArea xy-between">
                    <div class="classification">
                        <div class="navs xy-between">
                            <div class="department jf">
                                <div class="departmentItem xy-center font-size14 cursor " :class="{
                                    departActive: departmentActive === i
                                }" v-for="(item, i) in departmentList" @click="selcetDepartment(i, item.Id)"
                                    :key="i">
                                    {{ item.HospitalClassName }}
                                </div>
                            </div>
                            <div class="more font-size14 xy-center cursor" @click="GotoDepartment">
                                更多
                            </div>
                        </div>

                        <div class="departmentIntroduce">
                            <div class="font-size16">
                                总题量：{{ introduce.num }}道
                            </div>
                            <div class="text font-size14">
                                {{ introduce.text }}
                            </div>
                        </div>

                        <div class="courage">
                            <div class="courageItem xy-center cursor" v-for="(item, i) in departmentTopicNum" :key="i"
                                @click="secondaryDepartment(item)">
                                <div class="yx-center">
                                    <div class="font-size16">
                                        {{ item.HospitalClassName }}
                                    </div>
                                    <div class="font-size14 shiti">
                                        试题：<span class="c-256CF4 font-size16">{{ item.SubjectCount }}道</span>
                                    </div>
                                </div>
                            </div>
                            <div class="font-size16 xy-center more cursor" @click="GotoDepartment">
                                更多
                            </div>
                        </div>
                    </div>
                    <div class="topicList">
                        <div class="topicListTit xy-between">
                            <div class="text jf">
                                <div class="line"></div>
                                <div class="font-size16">
                                    模拟试卷
                                </div>
                            </div>
                            <div class="more c-72777F font-size16 cursor" @click="moreYearTopic">
                                更多
                            </div>
                        </div>

                        <ul class="zhentiList">
                            <li class="zhentiListItem one-wrap font-size14 cursor" v-for="(item, i) in highTopicList"
                                :key="i" @click="Edit(item)">
                                {{ item.chapter_name }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 在线考试 -->
            <div class="inlineTest">
                <div class="tit font-size24 c-256CF4 xy-center">
                    <img src="../../assets/img/qualificationTit.png" alt="" />
                    在线考试
                </div>
                <div class="xy-center littleTit">
                    <div class="yx-center">
                        <div class="font-size18 ">更多题库&nbsp;更多功能</div>
                        <div class="font-size14 c-32353A moreTopicLibary">
                            让考试更简单
                        </div>
                    </div>
                </div>

                <div class="service xy-between">
                    <div class="process ">
                        <div class="image xy-center">
                            <img src="../../assets/img/server.png" alt="" />
                        </div>

                        <div>
                            <div class="titText yx-center">
                                <div class="font-size18 bold">全流程服务</div>
                                <div class="c-32353A">
                                    Whole process service
                                </div>
                            </div>
                            <div class="font-size14 littleText">
                                出题、组卷、考试、阅卷、统计分析全周期管理；海量资源帮助机构打造专属题库，考试组织和流程管理一体化。
                            </div>
                        </div>
                    </div>

                    <div class="process ">
                        <div class="image xy-center">
                            <img src="../../assets/img/shiti.png" alt="" />
                        </div>

                        <div>
                            <div class="titText yx-center">
                                <div class="font-size18 bold">
                                    试题录入灵活&nbsp;•&nbsp;组卷方式多样
                                </div>
                                <div class="c-32353A  text-center">
                                    Flexible entry of test questions and various
                                    ways of generating test papers
                                </div>
                            </div>
                            <div class="font-size14 littleText">
                                试题可通过模板导入、智能批量录入、单题新增等方式灵活添加；手动抽题、系统抽题、随机抽题等多种组卷方式，满足更多考试场景。
                            </div>
                        </div>
                    </div>

                    <div class="process ">
                        <div class="image xy-center">
                            <img src="../../assets/img/kaochang.png" alt="" />
                        </div>

                        <div>
                            <div class="titText yx-center">
                                <div class="font-size18 bold">
                                    多项考场设置&nbsp;•&nbsp;全面考情分析
                                </div>
                                <div class="c-32353A text-center">
                                    Comprehensive analysis of multiple
                                    examination room settings
                                </div>
                            </div>
                            <div class="font-size14 littleText">
                                自定义考生参考次数、设置考场密码、试题乱序、指定人员参加考试；分数段、成绩排名、答题情况、分题统计、机构层级等维度统计分析，帮助组织者全面掌握考试情况。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 在线考试 -->
        </div>

        <!-- 客户案例 -->
        <div class="customerCase">
            <div class="cintain">
                <div class="tit font-size24 xy-center">
                    <img src="../../assets/img/qualificationTit.png" alt="" />
                    他们也在使用
                </div>

                <ul class="customerCaseInfo ">
                    <div class="customeContainBox">
                        <div class="customerBox" ref="customerBox">
                            <li class="customerItem xy-center font-size14" :class="{ leftStyle: i === 7 }"
                                ref="customerBoxItem" v-for="(item, i) in GroupUserList" :key="i">
                                <div class="son xy-center two-wrap ">
                                    <span class="name"> {{ item.Name }}</span>
                                </div>
                            </li>
                        </div>
                    </div>
                </ul>
            </div>
        </div>
        <!-- 客户案例 -->
        <bottom-ground></bottom-ground>
        <login-diolog :show.sync="loginDiologShow" @judegIslogin="judgeLogin"
            @changeLoginState="haveLogin"></login-diolog>

    </div>
</template>

<script>
import { GetFirstSystemCategoryInfo } from "@/api/category";
import { accountLogin, GetGroupUser } from "@/api/user";
import {
    GetCategoryModuleTypeCount,
    GetQuestionTypeCountNew,
    GetQuestionChildTypeCountNew
} from "@/api/course";
import { GetExamLit, GetHomeColumnPaper, GetExamInfo } from "@/api/exam";
import PageHeader from "@/components/HomeHeader";
import LoginDiolog from "@/components/loginDiolog";
import TheSlider from "@/components/sliding";
import BottomGround from "@/components/bottomnav";
import { HOME_PAGE_MAP } from "@/utils/platform-config";
import { showWarningBar } from "../../utils/maintainTime";

export default {
    components: {
        PageHeader,
        LoginDiolog,
        TheSlider,
        BottomGround,
    },
    watch: {
        $route: {
            handler(nv, ov) {
                this.$refs.pageHeader.judgeIsLogin();
            },
            deep: true
        }
    },
    created() {
        this.GetFirstSystemCategoryInfo();

        this.GetQuestionTypeCountNew();
        this.GetQuestionChildTypeCountNew(1);
        this.GetGroupUser();

        this.GetExamInfo();
        if (this.$route.query.login === "1" && !this.$store.getters.isLogin) {
            this.goLogin();
        }
    },
    mounted() {
        window.addEventListener("scroll", this.scrollHandle);
        this.controlSpeed();
    },

    destroyed() {
        clearInterval(this.timer);
    },
    data() {
        return {
            partnerTimer: "",
            initialTime: 0.5,
            list_img: [
                {
                    url: require("../../assets/img/banner3.jpg")
                },
                {
                    url: require("../../assets/img/banner2.jpg")
                }
            ],
            practitionersList: [],
            departActive: 1,
            departmentActive: 0,
            isShowHeader: false,
            loginDiologShow: false,
            isHaveLoginObj: "",
            physiciansList: [], // 执业医师
            ractitionerAssistant: [], // 执业医师助理
            LicensedPharmacists: [], // 执业药师
            nursePharmacists: [], // 护士执业资格
            HealthQualification: [], // 卫生专业技术资格
            hospitalTest: [], // 住院医师规范化培训考试
            medicalSankiList: [], // 住院医师规范化培训考试
            departmentList: [],
            introduce: {},
            departmentTopicNum: [],
            highTopicList: [],
            GroupUserList: [],
            columName: {},
            ExamListInfo: [],
            timer: "",
            stepLength: -0.25
        };
    },
    computed: {
        showWarningBar,
        token() {
            return this.$store.state.user;
        },
        scrollY() {
            return this.$store.getters.recruitScrollY;
        }
    },
    methods: {
        judgeLogin() {
            this.$refs.pageHeader.judgeIsLogin();
        },
        moduleClick() {
            if (!this.$store.state.groupInfo.IsIPAuthorize && !this.$store.getters.isLogin) {
                this.goLogin();
                return;
            }
            this.$router.push("/question/public");
        },
        // 更多历年真题
        moreYearTopic() {
            // 判断是否登录
            if (!this.$store.state.groupInfo.IsIPAuthorize && !this.$store.getters.isLogin) {
                this.goLogin();
                return;
            }
            this.$router.push({
                path: "/question/allQuestions",
                query: {
                    queryId:
                        "20180620020122-b9493b79-a00c-4549-b647-9879d59eee94",
                    from: "home"
                }
            });
        },
        // 控制速度
        controlSpeed() {
            let speed = 0;
            this.timer = setInterval(() => {
                let num = this.ExamListInfo.length;
                this.$nextTick(() => {
                    this.$refs.alertsBox.style.transform = `translateY(${this
                        .stepLength * speed}rem)`;
                    this.$refs.alertsBox.style.transitionDuration = "0.5s";
                });
                if (speed >= num - 1) {
                    speed = 0;
                    this.stepLength = 0.25;
                } else {
                    speed++;
                    this.stepLength = -0.25;
                }
            }, 3000);
        },
        async GetExamInfo() {
            try {
                const { data } = await GetExamInfo();
                data.data.forEach((item) => {
                    item.BeginTime = item.BeginTime.slice(0, 16);
                    item.EndTime = item.EndTime.slice(0, 16);
                });
                this.ExamListInfo = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        jumpTopic(id) {
            // 判断是否登录
            if (!this.$store.state.groupInfo.IsIPAuthorize && !this.$store.getters.isLogin) {
                this.goLogin();
                return;
            }
            this.$router.push({
                path: "/question/public",
                query: {
                    queryId: id,
                    from: "fristColum"
                }
            });
        },
        // 获取第一级的内容
        async GetFirstSystemCategoryInfo() {
            this.practitionersList = [];
            try {
                const { data } = await GetFirstSystemCategoryInfo();
                this.practitionersList = data.data.slice(0, 8);
                this.practitionersList.forEach((v, i) => {
                    this.columName[i] = v;
                });
                this.GetPhysicians();
                this.PrimaryHealth();
                this.GetProfessional();
                this.GetHighProfessional();
                this.GetviceHighProfessional();
                this.hospitalPhysicians();
                this.medicalSanki();
                this.GetHomeColumnPaper();
            } catch (error) {
            }
        },
        async GetGroupUser() {
            try {
                const { data } = await GetGroupUser({
                    id: 1
                });
                data.data.forEach((v, i) => {
                    if (i < 21) {
                        this.GroupUserList.push(v);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        async GetHomeColumnPaper() {
            this.highTopicList = [];
            try {
                const { data } = await GetHomeColumnPaper({
                    categoryId:
                        "20181207105838-adfc54a4-7e16-4902-a911-51bf9410ee48",
                    searchKey: "模拟试卷",
                    pageno: 2,
                    pagesize: 9
                });
                this.highTopicList = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        async GetQuestionChildTypeCountNew(val) {
            try {
                const { data } = await GetQuestionChildTypeCountNew({
                    typeId: val
                });
                if (data.data && data.data.length > 7) {
                    data.data.forEach((v, i) => {
                        if (i <= 6) {
                            this.departmentTopicNum.push(v);
                        }
                    });
                } else {
                    this.departmentTopicNum = data.data;
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 获取当前科室的详情
        getIntroDuce(val) {
            this.departmentList.forEach((v, i) => {
                if (val === i) {
                    this.introduce.num = v.SubjectCount;
                    this.introduce.text = v.Remark;
                }
            });
        },
        selcetDepartment(i, id) {
            this.departActive = id;
            this.departmentActive = i;
            this.getIntroDuce(i);
            this.departmentTopicNum = [];
            this.GetQuestionChildTypeCountNew(id);
        },
        secondaryDepartment(val) {
            // 判断是否登录
            if (!this.$store.state.groupInfo.IsIPAuthorize && !this.$store.getters.isLogin) {
                this.goLogin();
                return;
            }
            this.$router.push({
                path: "/question/department",
                query: {
                    fristId: this.departActive,
                    secondId: val.Id
                }
            });
        },
        async GetQuestionTypeCountNew() {
            try {
                const { data } = await GetQuestionTypeCountNew();
                if (data.data && data.data.length > 7) {
                    data.data.forEach((v, i) => {
                        if (i <= 6) {
                            this.departmentList.push(v);
                        }
                    });
                }
                this.getIntroDuce(0);
            } catch (error) {
                console.log(error);
            }
        },
        clearLoginObj() {
            this.isHaveLoginObj = "{}";
        },
        haveLogin(val) {
            this.isHaveLoginObj = val;
            this.$refs.pageHeader.judgeIsLogin();
        },
        goLogin() {
            this.loginDiologShow = true;
        },
        scrollHandle() {
            if (
                document.body.scrollTop > 450 ||
                document.documentElement.scrollTop > 450
            ) {
                this.isShowHeader = true;
            } else {
                this.isShowHeader = false;
            }
        },
        //  执业医师
        async GetPhysicians() {
            try {
                const { data } = await GetCategoryModuleTypeCount({
                    id: this.columName[0].id
                });
                this.physiciansList = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        // 初级卫生专业技术资格考试
        async PrimaryHealth() {
            try {
                const { data } = await GetCategoryModuleTypeCount({
                    id: this.columName[1].id
                });
                this.ractitionerAssistant = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        // 中级卫生专业技术资格考试
        async GetProfessional() {
            try {
                const { data } = await GetCategoryModuleTypeCount({
                    id: this.columName[2].id
                });
                this.LicensedPharmacists = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        // 高级卫生专业技术资格考试(正高)
        async GetHighProfessional() {
            try {
                const { data } = await GetCategoryModuleTypeCount({
                    id: this.columName[3].id
                });
                this.nursePharmacists = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        // 高级卫生专业技术资格考试(副高)
        async GetviceHighProfessional() {
            try {
                const { data } = await GetCategoryModuleTypeCount({
                    id: this.columName[4].id
                });
                this.HealthQualification = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        // 住院医师规培结业考核
        async hospitalPhysicians() {
            try {
                const { data } = await GetCategoryModuleTypeCount({
                    id: this.columName[5].id
                });
                this.hospitalTest = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        // 医学三基
        async medicalSanki() {
            try {
                const { data } = await GetCategoryModuleTypeCount({
                    id: this.columName[7].id
                });
                this.medicalSankiList = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        // 历年真题
        Edit(val) {
            // 判断是否登录
            if (!this.$store.state.groupInfo.IsIPAuthorize && !this.$store.getters.isLogin) {
                this.goLogin();
                return;
            }
            let obj = {};
            obj.type = "practice";
            obj.info = val;
            obj.columName = val.chapter_name;
            obj.allQuestions = 1;
            window.localStorage.setItem("TopicInfo", JSON.stringify(obj));
            this.$router.push("/publicMake");
        },
        GotoDepartment() {
            // 判断是否登录
            if (!this.$store.state.groupInfo.IsIPAuthorize && !this.$store.getters.isLogin) {
                this.goLogin();
                return;
            }
            this.$router.push({
                path: "/question/department",
                query: {
                    fristId: this.departActive
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    margin: 0 auto;

    .backImg {
        ::v-deep .el-carousel__container {
            height: 570px;

            .small {
                margin: 0;

                img {
                    width: 100%;
                }
            }
        }

        ::v-deep .el-carousel__indicators--horizontal {
            bottom: 60px;
        }
    }

    .centerContainBox {
        position: relative;
        top: -60px;
        width: 62.5%;
        margin: 0 auto;
        z-index: 100;

        .groupPaperBox {
            width: 100%;
            height: 121px;
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 0px 2px 40px 0px rgba(229, 232, 236, 0.8);
        }

        .groupPaperBox {
            .groupItem {
                height: 47px;
                width: 400px;
                border-right: 1px solid #f3f5f9;

                img {
                    width: 42px;
                    margin-right: 30px;
                }

                .text {
                    height: 100%;
                }
            }

            .three {
                border: none;
            }
        }

        .alerts {
            margin: 40px 0 80px 0;
            width: 100%;
            height: 50px;
            border: 1px solid white;
            padding: 0px 30px;
            box-sizing: border-box;
            color: white;
            border-radius: 6px;
            overflow: hidden;

            .image {
                width: 50px;
                margin: 5px 50px 0 30px;

                img {
                    width: 100%;
                }
            }

            .organ {
                width: 350px;
                color: black;
            }

            .text {
                width: 550px;
                padding-left: 50px;
                color: black;
            }

            .time {
                width: 300px;
                color: black;
            }

            .more {
                width: 50px;
                text-align: right;
            }

            .alertsBox {
                height: 100%;
                width: 100%;

                .examItem {
                    color: #333;
                    font-size: 16px;
                    height: 100%;

                    .image {
                        margin-left: 0;
                    }
                }
            }
        }

        .qualification {
            width: 100%;

            .tit {
                width: 300px;
                position: relative;
                margin: 0 auto;

                img {
                    width: 300px;
                    position: absolute;
                    left: 0;
                }
            }

            .module {
                list-style: none;
                width: 100%;
                padding: 0;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;

                &::after {
                    content: "";
                    width: 270px;
                    height: 0;
                    visibility: hidden;
                }

                .moduleItem {
                    background-color: white;
                    background-size: 100%;
                    width: 270px;
                    height: 242px;
                    margin-top: 40px;
                    margin-right: 17px;
                    box-shadow: 0px 2px 40px 0px rgba(229, 232, 236, 0.8);
                    border-radius: 12px;
                    position: relative;

                    .liteeBox {
                        img {
                            width: 100px;
                            margin-bottom: 30px;
                        }

                        .columtext {
                            position: absolute;
                            bottom: 40px;
                            width: 200px;
                            height: 30px;
                            text-align: center;
                        }
                    }
                }

                .moduleItem:nth-child(4n) {
                    margin-right: 0;
                }

                .practitioners:hover {
                    background: url("../../assets/img/allowLeftBack.png");
                    background-size: 100% 100%;
                    z-index: 300;
                    box-shadow: 0px 2px 30px 0px #c2d0df;
                }

                .practitionersHover {
                    display: none;

                    .content {
                        border-bottom: 1px solid #e5e8ec;
                        padding: 0 30px;
                        box-sizing: border-box;

                        .imgText {
                            position: relative;
                            width: 80px;
                            height: 80px;
                            color: white;

                            img {
                                width: 80px;
                                position: absolute;
                                z-index: -1;
                            }

                            .text {
                                width: 40px;
                                height: 40px;
                                margin-top: 15px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: wrap;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }

                        // 滑块
                    }
                }

                //  .practitioners:hover .practitionersHover
                .practitioners:hover .practitionersHover {
                    width: 930px;
                    max-height: 530px;
                    position: absolute;
                    left: 272px;
                    top: 0;
                    z-index: 201;
                    background: #ffffff;
                    box-shadow: 0px 2px 30px 0px #d2dde7;
                    border-radius: 12px;
                    display: block;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        border-radius: 6px;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 6px;
                        background: #bac0ca;
                    }
                }

                .Assistant:hover {
                    background: url("../../assets/img/allowBottom.png");
                    background-size: 100% 100%;
                    z-index: 300;
                    box-shadow: 0px 2px 30px 0px #c2d0df;
                }

                .AssistantHover {
                    display: none;

                    .content {
                        border-bottom: 1px solid #e5e8ec;
                        padding: 0 30px;
                        box-sizing: border-box;

                        .imgText {
                            position: relative;
                            width: 80px;
                            height: 80px;
                            color: white;

                            img {
                                width: 80px;
                                position: absolute;
                                z-index: -1;
                            }

                            .text {
                                width: 40px;
                                height: 40px;
                                margin-top: 15px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: wrap;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .chapterInfoBox {
                            width: 640px;
                            height: 132px;

                            .chapterInfo {
                                width: 200px;
                                height: 80px;
                                background: #f8faff;
                                border-radius: 12px;

                                .name {
                                    width: 40px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    font-size: 16px;
                                }

                                .topicNum {
                                    margin-left: 20px;
                                    font-size: 14px;
                                    color: #2f3134;

                                    .topicTotal {
                                        margin-top: 5px;
                                    }
                                }
                            }
                        }

                        .leftRow {
                            // width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }

                        .rightRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }
                    }
                }

                .Assistant:hover .AssistantHover {
                    width: 930px;
                    max-height: 530px;
                    position: absolute;
                    top: 242px;
                    z-index: 201;
                    background: #ffffff;
                    box-shadow: 0px 2px 30px 0px #d2dde7;
                    border-radius: 12px;
                    display: block;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        border-radius: 6px;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 6px;
                        background: #bac0ca;
                    }
                }

                .pharmacist:hover {
                    background: url("../../assets/img/allowBottom.png");
                    background-size: 100% 100%;
                    z-index: 300;
                    box-shadow: 0px 2px 30px 0px #c2d0df;
                }

                .pharmacistHover {
                    display: none;

                    .content {
                        border-bottom: 1px solid #e5e8ec;
                        padding: 0 30px;
                        box-sizing: border-box;

                        .imgText {
                            position: relative;
                            width: 80px;
                            height: 80px;
                            color: white;

                            img {
                                width: 80px;
                                position: absolute;
                                z-index: -1;
                            }

                            .text {
                                width: 40px;
                                height: 40px;
                                margin-top: 15px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: wrap;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .chapterInfoBox {
                            width: 640px;
                            height: 132px;

                            .chapterInfo {
                                width: 200px;
                                height: 80px;
                                background: #f8faff;
                                border-radius: 12px;

                                .name {
                                    width: 40px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    font-size: 16px;
                                }

                                .topicNum {
                                    margin-left: 20px;
                                    font-size: 14px;
                                    color: #2f3134;

                                    .topicTotal {
                                        margin-top: 5px;
                                    }
                                }
                            }
                        }

                        .leftRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }

                        .rightRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }
                    }
                }

                .pharmacist:hover .pharmacistHover {
                    width: 930px;
                    max-height: 530px;
                    position: absolute;
                    top: 242px;
                    z-index: 201;
                    background: #ffffff;
                    box-shadow: 0px 2px 30px 0px #d2dde7;
                    border-radius: 12px;
                    display: block;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        border-radius: 6px;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 6px;
                        background: #bac0ca;
                    }
                }

                .nurse:hover {
                    background: url("../../assets/img/allowrightBack.png");
                    background-size: 100% 100%;
                    z-index: 300;
                    box-shadow: 0px 2px 30px 0px #c2d0df;
                }

                .nursetHover {
                    display: none;

                    .content {
                        border-bottom: 1px solid #e5e8ec;
                        padding: 0 30px;
                        box-sizing: border-box;

                        .imgText {
                            position: relative;
                            width: 80px;
                            height: 80px;
                            color: white;

                            img {
                                width: 80px;
                                position: absolute;
                                z-index: -1;
                            }

                            .text {
                                width: 40px;
                                height: 40px;
                                margin-top: 15px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: wrap;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .chapterInfoBox {
                            width: 640px;
                            height: 132px;

                            .chapterInfo {
                                width: 200px;
                                height: 80px;
                                background: #f8faff;
                                border-radius: 12px;

                                .name {
                                    width: 40px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    font-size: 16px;
                                }

                                .topicNum {
                                    margin-left: 20px;
                                    font-size: 14px;
                                    color: #2f3134;

                                    .topicTotal {
                                        margin-top: 5px;
                                    }
                                }
                            }
                        }

                        .leftRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }

                        .rightRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }
                    }
                }

                .nurse:hover .nursetHover {
                    width: 930px;
                    max-height: 530px;
                    position: absolute;
                    top: 0;
                    right: 272px;
                    z-index: 201;
                    background: #ffffff;
                    box-shadow: 0px 2px 30px 0px #d2dde7;
                    border-radius: 12px;
                    display: block;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        border-radius: 6px;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 6px;
                        background: #bac0ca;
                    }
                }

                .health:hover {
                    background: url("../../assets/img/allowLeftBack.png");
                    background-size: 100% 100%;
                    z-index: 300;
                    box-shadow: 0px 2px 30px 0px #c2d0df;
                }

                .healthHover {
                    display: none;

                    .content {
                        border-bottom: 1px solid #e5e8ec;
                        padding: 0 30px;
                        box-sizing: border-box;

                        .imgText {
                            position: relative;
                            width: 80px;
                            height: 80px;
                            color: white;

                            img {
                                width: 80px;
                                position: absolute;
                                z-index: -1;
                            }

                            .text {
                                width: 40px;
                                height: 40px;
                                margin-top: 15px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: wrap;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .chapterInfoBox {
                            width: 640px;
                            height: 132px;

                            .chapterInfo {
                                width: 200px;
                                height: 80px;
                                background: #f8faff;
                                border-radius: 12px;

                                .name {
                                    width: 40px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    font-size: 16px;
                                }

                                .topicNum {
                                    margin-left: 20px;
                                    font-size: 14px;
                                    color: #2f3134;

                                    .topicTotal {
                                        margin-top: 5px;
                                    }
                                }
                            }
                        }

                        .leftRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }

                        .rightRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }
                    }
                }

                .health:hover .healthHover {
                    width: 930px;
                    max-height: 530px;
                    position: absolute;
                    left: 272px;
                    bottom: 0;
                    z-index: 201;
                    background: #ffffff;
                    box-shadow: 0px 2px 30px 0px #d2dde7;
                    border-radius: 12px;
                    display: block;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        border-radius: 6px;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 6px;
                        background: #bac0ca;
                    }
                }

                .hospital:hover {
                    background: url("../../assets/img/alloeTop.png");
                    background-size: 100% 100%;
                    z-index: 300;
                    box-shadow: 0px 2px 30px 0px #c2d0df;
                }

                .hospitalHover {
                    display: none;

                    .content {
                        border-bottom: 1px solid #e5e8ec;
                        padding: 0 30px;
                        box-sizing: border-box;

                        .imgText {
                            position: relative;
                            width: 80px;
                            height: 80px;
                            color: white;

                            img {
                                width: 80px;
                                position: absolute;
                                z-index: -1;
                            }

                            .text {
                                width: 40px;
                                height: 40px;
                                margin-top: 15px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: wrap;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .chapterInfoBox {
                            width: 640px;
                            height: 132px;

                            .chapterInfo {
                                width: 200px;
                                height: 80px;
                                background: #f8faff;
                                border-radius: 12px;

                                .name {
                                    width: 40px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    font-size: 16px;
                                }

                                .topicNum {
                                    margin-left: 20px;
                                    font-size: 14px;
                                    color: #2f3134;

                                    .topicTotal {
                                        margin-top: 5px;
                                    }
                                }
                            }
                        }

                        .leftRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }

                        .rightRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }
                    }
                }

                .hospital:hover .hospitalHover {
                    width: 930px;
                    max-height: 530px;
                    position: absolute;
                    bottom: 242px;
                    z-index: 201;
                    background: #ffffff;
                    box-shadow: 0px 2px 30px 0px #d2dde7;
                    border-radius: 12px;
                    display: block;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        border-radius: 6px;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 6px;
                        background: #bac0ca;
                    }
                }

                .sanki:hover {
                    background: url("../../assets/img/alloeTop.png");
                    background-size: 100% 100%;
                    z-index: 300;
                    box-shadow: 0px 2px 30px 0px #c2d0df;
                }

                .sankiHover {
                    display: none;

                    .content {
                        border-bottom: 1px solid #e5e8ec;
                        padding: 0 30px;
                        box-sizing: border-box;

                        .imgText {
                            position: relative;
                            width: 80px;
                            height: 80px;
                            color: white;

                            img {
                                width: 80px;
                                position: absolute;
                                z-index: -1;
                            }

                            .text {
                                width: 40px;
                                height: 40px;
                                margin-top: 15px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: wrap;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .chapterInfoBox {
                            width: 640px;
                            height: 132px;

                            .chapterInfo {
                                width: 200px;
                                height: 80px;
                                background: #f8faff;
                                border-radius: 12px;

                                .name {
                                    width: 40px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    font-size: 16px;
                                }

                                .topicNum {
                                    margin-left: 20px;
                                    font-size: 14px;
                                    color: #2f3134;

                                    .topicTotal {
                                        margin-top: 5px;
                                    }
                                }
                            }
                        }

                        .leftRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }

                        .rightRow {
                            width: 36px;
                            height: 48px;
                            background: #f3f5f9;
                            border-radius: 3px;
                            margin: 0 20px;
                        }
                    }
                }

                .sanki:hover .sankiHover {
                    width: 930px;
                    max-height: 530px;
                    position: absolute;
                    bottom: 242px;
                    z-index: 201;
                    background: #ffffff;
                    box-shadow: 0px 2px 30px 0px #d2dde7;
                    border-radius: 12px;
                    display: block;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        border-radius: 6px;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 6px;
                        background: #bac0ca;
                    }
                }
            }
        }

        //   科室样式
        .navigation {
            width: 100%;

            .tit {
                width: 300px;
                position: relative;
                margin: 0 auto;
                margin-top: 100px;
                margin-bottom: 50px;

                img {
                    width: 300px;
                    position: absolute;
                    left: 0;
                }
            }

            .contentArea {
                width: 100%;
                height: 530px;

                .classification {
                    width: 906px;
                    height: 100%;
                    box-shadow: 0px 6px 30px 0px rgba(222, 224, 232, 0.5);
                    border-radius: 8px;
                    background-color: white;
                    padding: 30px;
                    box-sizing: border-box;

                    .navs {
                        .department {
                            width: 780px;
                            height: 30px;

                            .departmentItem {
                                width: 97px;
                                height: 40px;
                                margin-left: 10px;
                                background-color: white;
                                box-shadow: 0px 6px 30px 0px rgba(222, 224, 232, 0.5);
                                border-radius: 8px;
                            }

                            .departActive {
                                background: linear-gradient(180deg,
                                        #4ba5fb 0%,
                                        #256cf4 100%);
                                color: white;
                            }
                        }

                        .more {
                            width: 70px;
                            height: 32px;
                            background: #ffffff;
                            border-radius: 3px;
                            border: 1px solid #256cf4;
                        }
                    }

                    .departmentIntroduce {
                        max-height: 180px;
                        overflow: auto;
                        width: 100%;
                        margin-top: 30px;
                        padding: 30px;
                        box-sizing: border-box;
                        border-radius: 8px;
                        color: white;
                        background: url("../../assets/img/totaLtOPICS.png") no-repeat;
                        background-size: 100% 100%;

                        .text {
                            line-height: 20px;
                            margin-top: 20px;
                        }
                    }

                    .courage {
                        width: 100%;
                        padding-top: 30px;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: row;
                        //两侧对齐
                        justify-content: space-between;
                        //自动换行
                        flex-wrap: wrap;
                        //清除上下行的中间空隙
                        align-content: flex-start;

                        .courageItem {
                            width: 190px;
                            height: 100px;
                            background: #f0f3f7;
                            border-radius: 8px;
                            float: left;
                            margin-bottom: 20px;

                            .shiti {
                                margin-top: 10px;
                            }
                        }

                        .more {
                            width: 190px;
                            height: 100px;
                            background: #f0f3f7;
                            border-radius: 8px;
                            display: flex;
                        }
                    }

                    .courage:after {
                        content: "";
                        width: 145px;
                    }
                }

                .topicList {
                    width: 274px;
                    height: 100%;
                    box-shadow: 0px 6px 30px 0px rgba(222, 224, 232, 0.5);
                    border-radius: 8px;
                    background-color: white;
                    padding: 20px;
                    box-sizing: border-box;

                    .topicListTit {
                        width: 100%;
                        border-bottom: 1px solid #eeeeee;
                        padding-bottom: 10px;
                        box-sizing: border-box;

                        .text {
                            .line {
                                width: 3px;
                                height: 16px;
                                background: #256cf4;
                                margin-right: 5px;
                            }
                        }
                    }

                    .zhentiList {
                        list-style: none;
                        padding: 0;

                        .zhentiListItem {
                            margin: 30px 0;
                        }
                    }
                }
            }
        }

        // 在线考试
        .inlineTest {
            width: 100%;

            .tit {
                width: 300px;
                position: relative;
                margin: 0 auto;
                margin-top: 100px;
                margin-bottom: 20px;

                img {
                    width: 300px;
                    position: absolute;
                    left: 0;
                }
            }

            .littleTit {
                .moreTopicLibary {
                    margin-top: 5px;
                }

                margin-bottom: 30px;
            }

            .service {
                .process {
                    width: 336px;
                    background: #ffffff;
                    box-shadow: 0px 4px 65px 0px rgba(218, 224, 235, 0.37);
                    border-radius: 12px;
                    padding: 30px;
                    box-sizing: border-box;
                    height: 400px;

                    // background-color: pink;
                    .image {
                        margin: 0px 0 10px 0;

                        img {
                            width: 120px;
                            border-radius: 50%;
                            box-shadow: 0px 2px 30px 0px #dae4f6;
                        }
                    }

                    .titText {
                        width: 100%;
                        margin-bottom: 20px;

                        .bold {
                            font-weight: bold;
                            font-family: AlibabaPuHuiTiM;
                            color: #32353a;
                            line-height: 35px;
                        }
                    }

                    .littleText {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 26px;
                    }
                }
            }
        }
    }

    .customerCase {
        height: 675px;
        // background: url("../../assets/img/customerCase.png"), white no-repeat;
        background-size: 100%;
        overflow: hidden;

        .cintain {
            width: 100%;
            // margin: 0 auto;
        }

        .tit {
            width: 380px;
            position: relative;
            margin: 0 auto;
            margin-top: 100px;
            margin-bottom: 20px;
            color: #256cf4;

            .images {
                width: 350px;
                position: absolute;
                left: 0;
            }

            img {
                width: 380px;
                position: absolute;
                left: 0;
            }
        }

        .customerCaseInfo {
            width: 1920px;
            list-style: none;
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            margin-top: 58px;

            .customeContainBox {
                width: 62.5%;
                height: 400px;
                margin: 0 auto;
                // overflow: hidden;
                position: relative;
            }

            .customerBox {
                width: 100%;
                height: 300px;
                display: flex;
                flex-wrap: wrap;

                .customerItem {
                    width: 100px;
                    height: 100px;
                    background: #d3e2fd;
                    transform: rotate(45deg);
                    border-radius: 20px;
                    margin-left: 60px;

                    .son {
                        width: 80px;
                        height: 40px;
                        transform: rotate(-45deg);
                        // color: white;
                        color: #256cf4;
                        text-align: center;
                    }
                }

                .leftStyle {
                    margin-left: 120px;
                }
            }

            .customerItem:nth-child(84) {
                margin-left: 130px;
            }
        }
    }

    .goTop {
        .selectType {
            list-style: none;
            width: 72px;
            height: 350px;
            background: #ffffff;
            box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
            border-radius: 8px;
            position: fixed;
            right: 40px;
            bottom: 125px;
            z-index: 1000;
            padding: 10px;
            box-sizing: border-box;

            img {
                width: 35px;
                height: 40px;
            }

            .routes {
                width: 56px;
                height: 83px;

                .icon {
                    margin-bottom: 7px;
                }
            }

            .routes:not(:first-child) {
                border-top: 1px solid #e5e8ec;
            }
        }

        .el-backtop {
            width: unset;
            right: 40px !important;
            bottom: 60px !important;

            .test {
                width: 72px;
                height: 72px;
                background: #ffffff;
                box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
                border-radius: 8px;
            }
        }
    }

    .test22 {
        width: 1920px;
        height: 1920px;
        background-color: pink;
    }

    .bottomImg {
        position: fixed;
        bottom: 0;
        z-index: 999999;

        .box {
            position: relative;

            img {
                width: 100%;
            }

            i {
                position: absolute;
                top: 10px;
                right: 380px;
                color: white;
            }
        }
    }
}

.top-notice {
    display: block;
    width: 100%;
    background: #fff7e8;
    color: #f57c00;
    font-size: 16px;
    line-height: 1.4;
    padding: 5px 20px;
    box-sizing: border-box;
}
</style>
